import { Typography } from '@mui/material'
import React from 'react'

const Nothing = () => {
  return (
    <>
      <Typography variant="h4" sx={{my: 10, textAlign: `center`}}>Nothing Found !</Typography>
    </>
  )
}

export default Nothing
